import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

class Animations {

	constructor(props) {
		this.props = props

		this.init()
	}

	init() {
		this.animate()
		this.animateGroup()
	}
	
	animate() {
		const animate = document.querySelectorAll('.animate')

        if (animate.length > 0) {

            animate.forEach((elem) => {
                ScrollTrigger.create({
                    trigger: elem,
                    toggleClass: 'show',
                    start: "top center+=100px",
                    // markers: true, // debugging
                    once: true
                })
            })

        }
	}

	animateGroup() {
		const animateGroup = document.querySelectorAll('.animate-group')

		if (animateGroup.length > 0) {

            animateGroup.forEach(elem => {

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: elem,
                        start: "top center+=100px",
                        once: true
                    }
                })

                gsap.defaults({
                    ease: 'ease-in-out',
                    duration: .5
                })

                const children = elem.querySelectorAll(':scope > *')

                const contentContainer = this.getContentContainer(children)

                let groupChildren;

                if (typeof contentContainer !== 'undefined') {
                    groupChildren = contentContainer.querySelectorAll(':scope > *')
                } else {
                    groupChildren = children
                }

                groupChildren.forEach(child => {
                    const childClass = [...child.classList]

                    if (childClass.includes('slide-left')) {
                        tl.fromTo(child, {xPercent: 15, opacity: 0}, {xPercent: 0, opacity: 1})
                    } else if (childClass.includes('slide-right')) {
                        tl.fromTo(child, {xPercent: -15, opacity: 0}, {xPercent: 0, opacity: 1})
                    } else if (childClass.includes('slide-up')) {
                        tl.fromTo(child, {yPercent: 15, opacity: 0}, {yPercent: 0, opacity: 1})
                    } else if (childClass.includes('slide-down')) {
                        tl.fromTo(child, {yPercent: -15, opacity: 0}, {yPercent: 0, opacity: 1})
                    } else if (childClass.includes('zoom-in')) {
                        tl.fromTo(child, {scale: .8, opacity: 0}, {scale: 1, opacity: 1})
                    } else if (childClass.includes('zoom-out')) {
                        tl.fromTo(child, {scale: 1.2, opacity: 0}, {scale: 1, opacity: 1})
                    } else {
                        tl.fromTo(child, {opacity: 0}, {opacity: 1})
                    }
                })
            })
        }
	}

    getContentContainer(children) {
        return [...children].find((child) => {
            return typeof [...child.classList].find(element => {
                const regex = new RegExp('__inner-container', 'g');
                return regex.test(element) === true;
            }) !== 'undefined'
        })
    }
}

export default Animations